import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Programs from './components/Programs/Programs';
import Title from './components/Title/Title';
import About from './components/About/About';
import Testimonials from './components/Testimonials/Testimonials';
import Footer from './components/Footer/Footer';

import { Link } from 'react-scroll';


import Develop from './components/Search/Develop';
import Partners from './components/Partners/Partners';
import Services from './components/Services/Services';
import Cluster from './components/Cluster/Cluster';
import Member from './components/Member/Member';

function App() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;

    const offset = location.state?.scrollOffset ?? -150;
    const timer = setTimeout(() => {
      scroller.scrollTo(target, { smooth: true, duration: 500, offset });
    }, 150);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      <div className="App">
        <div className='navbar__con'>
          <Navbar />
        </div>
       
        <Hero />
        <div className='container'>
         
         <Programs />
         <Title subtitle='We are the creative network uniting individual and collective businesses to create unique area for fast internationalisation and development.' title='' />
         <Testimonials />
         <Title subtitle='We are experienced in supporting business' title='Who are we?' />
         <About />
         <Title title='Our partners'/>
         <Partners/>
         <Title subtitle='We are open to those who are ready to collaborate and develop in the innovation and craft sector.' title='Who is our member?' />
         <Develop/>
         <Member/>
         <Title title='Our services'/>
         <Services/>
         <Title title='Become a part of our Creative Cluster'/>
         <Cluster/>
         <Footer/>
        </div>       
      </div>
    </>

  );
}

export default App;

